import React from 'react';
import { 
  Accordion, 
  AccordionSummary, 
  AccordionDetails, 
  Typography,
  Grid,
  Link
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useStyles } from './style';


interface VideoItemProps {
  title: string;
  description: string;
  video: string;
}

export const VideoItem = ({ title, description, video }: VideoItemProps) => {
  const classes = useStyles();
  
  // Check if the video URL is from Vimeo
  const isVimeoVideo = video.includes('vimeo.com');
  
  // Extract Vimeo video ID and convert to embed URL
  const getVimeoEmbedUrl = (vimeoUrl: string) => {
    const videoId = vimeoUrl.match(/vimeo\.com\/(\d+)/)?.[1];
    if (videoId) {
      return `https://player.vimeo.com/video/${videoId}`;
    }
    return vimeoUrl;
  };

  return (
    <Grid item xs={12} sm={12} md={6} className={classes.videoItem}>
      {isVimeoVideo ? (
        <div style={{padding: '46.25% 0 0 0', position: 'relative'}}>
          <iframe src={getVimeoEmbedUrl(video)} frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%'}} title={title}></iframe>
          <script src="https://player.vimeo.com/api/player.js"></script>
        </div>
      ) : (
        <video 
          src={video} 
          controls
          title="Video"
          style={{ width: '100%', height: 'auto' }}
        >
          Your browser does not support the video tag.
        </video>
      )}
      <Typography variant="h4" className={classes.videoItemTitle}>{title}</Typography>
      <Typography variant="body1" className={classes.videoItemDescription}>{description}</Typography>
    </Grid>
  );
};


interface FAQProps {
  expanded: boolean;
  onChange: (event: React.SyntheticEvent, isExpanded: boolean) => void;
  question: string;
  answer: string;
}

export const FAQ = ({ expanded, onChange, question, answer }: FAQProps) => {
  const classes = useStyles();

  return (
    <Grid item xs={12} sm={12} md={6} sx={{ px: 4 }}>
      <Accordion expanded={expanded} onChange={onChange}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography>{question}</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography dangerouslySetInnerHTML={{ __html: answer }} />
          </AccordionDetails>
      </Accordion>
    </Grid>
  );
};

// Shared utility function for handling card clicks
export const handleCardClick = (path: string, navigate: (path: string) => void) => {
  // Check if the path is a full URL (starts with http:// or https://)
  const isExternalUrl = path.startsWith('http://') || path.startsWith('https://');
  
  if (isExternalUrl) {
    // Open external URL in a new tab
    window.open(path, '_blank', 'noopener,noreferrer');
  } else {
    // Navigate to internal route
    navigate(path);
  }
};
